import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { toHttpParams } from "src/app/core/helpers/http-params-extensions"
import { HttpClient } from "@angular/common/http"
import { SubjectSetCreateUpdateRequest, SubjectSetUpdateRequest } from "../models/subject-set/subject-set-create-update-request"


@Injectable({
  providedIn: "root",
})
export class SubjectSetService {
  private get_subject_set_paginate_url: string
  private delete_subject_set_url: string
  private post_subject_set_url: string
  private get_subject_set_id_url: string
  private put_subject_set_url: string
  private get_set_schools_paginate_url: string
  private get_school_options_url: string

  private buildUrls(subjectUrl: string) {
    this.get_subject_set_paginate_url =
      subjectUrl + environment.endpointSetGateway.routes.get_set_paginate

    this.delete_subject_set_url =
      subjectUrl + environment.endpointSetGateway.routes.delete_subject_set

    this.post_subject_set_url =
      subjectUrl + environment.endpointSetGateway.routes.post_subject_set

    this.get_subject_set_id_url =
      subjectUrl + environment.endpointSetGateway.routes.get_subject_set_id

    this.put_subject_set_url =
      subjectUrl + environment.endpointSetGateway.routes.put_subject_set

    this.get_set_schools_paginate_url =
      subjectUrl + environment.endpointSetGateway.routes.get_set_schools_paginate

    this.get_school_options_url =
      subjectUrl + environment.endpointSetGateway.routes.get_school_options
  }

  constructor(private http: HttpClient) {
    this.buildUrls(environment.endpointSetGateway.url)
  }

  getPaginate(data) {
    let params = toHttpParams(data)
    return this.http.get(this.get_subject_set_paginate_url, { params })
  }

  delete(subjectId: string) {
    return this.http.delete(
      this.delete_subject_set_url.replace("{setId}", subjectId)
    )
  }

  post(model: SubjectSetCreateUpdateRequest) {
    return this.http.post(this.post_subject_set_url, model)
  }

  getOneSubjectSet(setId: string) {
    return this.http.get(this.get_subject_set_id_url.replace("{setId}", setId))
  }

  put(model: SubjectSetUpdateRequest) {
    return this.http.put(this.put_subject_set_url.replace("{setId}", model.id), model)
  }

  getSetSchoolsPaginate(data) {
    let params = toHttpParams(data)
    return this.http.get(this.get_set_schools_paginate_url, { params })
  }

  getSchoolsOptions(setId: string) {
    return this.http.get(this.get_school_options_url.replace("{setId}", setId))
  }

}
